import {
    APP_CONFIG
} from "../constants/global-variables.js";




export async function accountBalanceOf(start_date, end_date, currency, roleId) {
    let role = roleId;
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/accountbalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function accountBalanceForChildrenOf(start_date, end_date, agent_id, currency, roleId) {

    let role = roleId;
    if(role == 'SuperMenager'){
        role = 'Supermanager'
    }else if(role == "Menager"){
        role = 'manager'
    }else if( role == "User"){
        return;
    }
    
    let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/accountbalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                children_id: agent_id,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}



export async function casinoBalanceOf(start_date, end_date, currency, roleId) {
    let role = roleId;
    if(role == 'SuperMenager'){
        role = 'supermanager'
    }else if(role == "Menager"){
        role = 'manager'
    }else if( role == "User"){
        return;
    }

    console.log('kahyre ketu 1sh')
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/casinobalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}


export async function livecasinoBalanceForChildrenOf(start_date, end_date, agent_id, currency, roleId) {
    let role = roleId;
    if(role == "Administrator"){
        role = 'Admin'
    }if(role == 'SuperMenager'){
        role = 'SuperManager'
    }else if(role == "Menager"){
        role = 'Manager'
    }else if(role == "Agent"){
        role = 'Agent'
    }else if( role == "User"){
        return;
    }

    console.log('kahyre ketu 1sh')
    console.log(roleId, 'qetuuuuu')
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/livecasinoBalanceOf${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                children_id: agent_id,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function casinoBalanceForChildrenOf(start_date, end_date, agent_id, currency, roleId) {

    console.log(roleId, 'roleId');
    let role = roleId;
    if(role == 'SuperMenager'){
        role = 'supermanager'
    }else if(role == "Menager"){
        role = 'manager'
    }else if(role == 'Supermanager'){
        role = 'supermanager'
    }else if( role == "User"){
        return;
    }

    console.log('kahyre ketu 2sh')
    let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/casinobalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                children_id: agent_id,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}


export async function gsCasinoBalanceForChildrenOf(start_date, end_date, agent_id, currency, roleId) {

    console.log(roleId, 'roleId');
    let role = roleId;
    if(role == "Administrator"){
        role = 'administrator'
    }if(role == 'Supermanager'){
        role = 'SuperManager'
    }else if(role == "Menager"){
        role = 'manager'
    }else if(role == "Agent"){
        role = 'agent'
    }else if( role == "User"){
        return;
    }

    console.log('kahyre ketu 2sh')
    let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/gscasinobalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                children_id: agent_id,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function virtualBalanceOf(start_date, end_date, currency, roleId) {
    let role = roleId;
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/virtualbalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function virtualBalanceForChildrenOf(start_date, end_date, agent_id, currency, roleId) {

    let role = roleId;
    if(role == 'SuperMenager'){
        role = 'supermanager'
    }else if(role == "Menager"){
        role = 'manager'
    }else if(role == "Administrator"){
        role = 'administrator'
    }else if(role == 'Supermanager'){
        role = 'supermanager'
    }else if( role == "User"){
        return;
    }
    let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/virtualbalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                children_id: agent_id,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function allBalanceOf(start_date, end_date, currency, roleId) {
    let role = roleId;
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allbalanceof${role}`;

    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}

export async function allBalanceForChildrenOf(start_date, end_date, agent_id, currency, roleId) {
    let role = roleId;
    let url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allbalanceof${role}`;
    try {
        const res = await axios.post(
            url, {
                start_date,
                end_date,
                children_id: agent_id,
                currency,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return res.data.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}